import { takeLatest, put, call, select, race, delay } from 'redux-saga/effects' //select, call,
import { getPricequotes } from '../../lib/requests/routesRequests'
import { delays } from '../../lib/constants'
import { getCurrentLang, getToken, getDicionary } from '../selectors'

export function* worker({ route, finishBtnFlow }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(getPricequotes, token, currentLang, route),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && (result.status === 200 || result.status === 202)) {
      yield put({ type: 'SET_BETS', payload: result.data.data })
      if (finishBtnFlow) {
        yield put({ type: 'CLOSE_BET_WINDOW', payload: true })
        yield put({ type: 'CLOSE_ERROR_API' })
      }
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* getTenderBets() {
  yield takeLatest('SAGA_GET_PRICEQUTES', worker)
}
